import { gallery__init } from './gallery/gallery'
import './gallery/cursor'

const init = () => {
  gallery__init(document.getElementById('gallery'))
}

window.onload = () => {
  init()
}